import React, { useContext, useState } from 'react';
import i18next from 'i18next';
import { Textlink } from '../../../../AutostadtTabComponents/Button';
import SubpageBlue from '../../SubpageBlue';
import './styles.scss';
import { Trans } from 'react-i18next';
import { OverlayEnum } from '../../../../../enums';
import { setOverlay } from '../../../../../utils/SspProvider/dispatchFunctions';
import SspProviderContext from '../../../../../utils/SspProvider/context';

export default function Arrival() {
    const store = useContext(SspProviderContext);
    const [selectedOption, setSelectedOption] = useState('train');

    return (
        <SubpageBlue
            title={i18next.t('ArrivalTitle')}
            className='arrival'
            headerChildren={
                <>
                    <p className='body large'>{i18next.t('ArrivalSubline')}</p>
                    <p className='body large bold'>{i18next.t('ArrivalBoldLineHeader')}</p>
                </>
            }
        >
            <section id='arrival'>
                <div className='button-container' role='group' aria-label='Travel options'>
                    <button
                        className={`${selectedOption === 'train' ? 'selected' : ''}`}
                        type='button'
                        aria-pressed={selectedOption === 'train'}
                        onClick={() => setSelectedOption('train')}
                    >
                        {i18next.t('ByTrain').toUpperCase()}
                    </button>
                    <button
                        className={`${selectedOption === 'car' ? 'selected' : ''}`}
                        type='button'
                        aria-pressed={selectedOption === 'car'}
                        onClick={() => setSelectedOption('car')}
                    >
                        {i18next.t('ByCar').toUpperCase()}
                    </button>
                </div>
                <div className='infobox-white' role='region' aria-live='polite'>
                    {selectedOption === 'car' && (
                        <div>
                            <p className='body large bold'>{i18next.t('OutwardJourney')}</p>
                            <p>
                                {' '}
                                <Trans
                                    i18nKey={'TravelingByCarSubline'}
                                    components={{
                                        strong: <strong />,
                                        br: <br />,
                                    }}
                                />
                            </p>
                            <p className='body large bold'>{i18next.t('TravelingByCarRental')}</p>
                            <p>
                                <Trans
                                    i18nKey={'TravelingByCarRentalSubline'}
                                    components={{
                                        strong: <strong />,
                                        br: <br />,
                                    }}
                                />
                            </p>
                            <p className='body large bold'>{i18next.t('TravelingByCarChargingElectricCars')}</p>
                            <p>
                                <Trans
                                    i18nKey={'TravelingByCarChargingElectricCarsSubline'}
                                    components={{
                                        strong: <strong />,
                                        br: <br />,
                                    }}
                                />
                            </p>
                            <p className='body large bold'>
                                <Trans
                                    i18nKey={'TravelingByCarCurrentTrafficInformation'}
                                    components={{
                                        strong: <strong />,
                                        br: <br />,
                                    }}
                                />
                            </p>
                            <p>
                                <Trans
                                    i18nKey={'TravelingByCarCurrentTrafficInformationSubline'}
                                    components={{
                                        strong: <strong />,
                                        br: <br />,
                                    }}
                                />
                            </p>
                            <Textlink
                                color={'dark-blue'}
                                text={i18next.t('LearnMore')}
                                svg='#as-link-external'
                                onClick={() => {
                                    setOverlay(store, {
                                        enum: OverlayEnum.ExternalContent,
                                        media: 'https://www.strassenbau.niedersachsen.de/startseite/aktuelles/die_autobahn_gmbh/planungs_und_bauprojekte_auf_bundesautobahnen/',
                                    });
                                }}
                            />
                        </div>
                    )}
                    {selectedOption === 'train' && (
                        <div>
                            <p className='body large bold'>{i18next.t('OutwardJourney')}</p>
                            <p>{i18next.t('TravelingByTrainSubline')}</p>

                            <p className='body large bold'>{i18next.t('TravelingByTrainMoreInfo')}</p>
                            <Textlink
                                color={'dark-blue'}
                                text={i18next.t('DBUrl')}
                                svg='#as-link-external'
                                onClick={() => {
                                    setOverlay(store, {
                                        enum: OverlayEnum.ExternalContent,
                                        media: 'https://www.bahn.de',
                                    });
                                }}
                            />
                            <p className='body large bold'>{i18next.t('TravelingByTrainDBDelay')}</p>
                            <Textlink
                                color={'dark-blue'}
                                text={i18next.t('LearnMore')}
                                svg='#as-link-external'
                                onClick={() => {
                                    setOverlay(store, {
                                        enum: OverlayEnum.ExternalContent,
                                        media: 'https://www.bahn.de/service/fahrplaene?dbkanal_007=L01_S01_D001_KIN_-rs-NAVIGATION-auskunft_LZ01',
                                    });
                                }}
                            />
                        </div>
                    )}
                </div>

                <div className='luggage'>
                    <svg>
                        <use xlinkHref='#as-luggage'></use>
                    </svg>
                    <h3>{i18next.t('ArrivalLuggageHeadline')}</h3>
                    <p className='body large'>{i18next.t('ArrivalLuggageSubline')}</p>
                </div>
            </section>
        </SubpageBlue>
    );
}
